export default __webpack_public_path__ + "static/media/kinuiCard.f092a6e0.webp";